export const shortHeaders: string[] = [
  /* 'N° Pedidos' */ 'Título',
  'N° Pedido',
  'Situação',
  'Data',
  'Valor Total',
  '',
]

export const shortFields: string[] = [
  /* 'placeholder' */ 'Title',
  'Id',
  'StageName',
  'CreateDate',
  'Amount',
]

export interface Order {
  Id: number
  Title: string
  OriginDealId: number
  StageName: string
  CreateDate: string
  Amount: number
}

export const headersToFields = {
  //Tabela de estoque
  Unidade: 'measurementUnit',
  //Tabela de movimentos
  Data: 'updatedAt',
}

export const fieldsToHeaders = {
  //Tabela de estoque
  measurementUnit: 'Unidade',
  //Tabela de movimentos
  updatedAt: 'Data',
}

export interface FieldsToHeaders {
  material: string
  format: string
  finishing: string
  fabrication: string
  dimension1: string
  lengthInMm: string
  quantity: string
  totalWeight: string
  costPerKg: string
  code: string
  dimension2: string
  heatTreatment: string
  density: string
  costPerMm: string
  ncm: string
  totalCost: string
  originCountry: string
  stockStreet: string
  shelf: string
  stockLocation: string
  certificates: string
  availableBalance: string
  totalCmc: string
  trackingNumber: string
  family: string
  description: string
  stockStatus: string
  characteristic: string
  receivedDate: string
  purchaseOrder: string
  nf: string
  certificateNumber: string
  runNumber: string
  supplier: string
  ploomesOrderId: string
  rawMaterialName: string
  status: string
  oldTotalWeight: string
  newTotalWeight: string
  oldLengthInMm: string
  newLengthInMm: string
  updatedAt: string
}

export const mappingStage: { [key: number]: string } = {
  10052601: 'Pedido recebido', //Pedido ganho
  50004575: 'Pedido recebido', //Pedido desmembrado
  50004000: 'Pedido recebido', //Aguardando Corte
  10052602: 'Corte em Execução', //Corte em execução
  50003998: 'Corte em Execução', //Aguardando forja
  10052603: 'Forjando', //Forjando
  50002534: 'Forjando', //Inspeção pós forjamento
  50004218: 'Forjando', //Aguardando corte secundário
  10092479: 'Corte Secundário', //Corte secundário
  50003999: 'Corte Secundário', //Aguardando usinagem
  50002532: 'Corte Secundário', //Usinagem em execução
  10063989: 'Enviar para terceiros', //Enviar p/ terceiros
  10052689: 'Em terceiros', //Em terceiros
  50004775: 'Em terceiros', //Aguardando relatório de terceiros
  50003813: 'Em terceiros', ///Levar amanhã
  50005340: 'Em terceiros', //Aguardando Certificado de Qualidade
  50003804: 'Em terceiros', //Separação e inspeção final
  10053355: 'Emissão NF', //Emissão NF
  50001470: 'Expedição', //Expedição
  10053356: 'Entregue/Coletado', //Entregue/Coletado
  50004576: 'Entregue/Coletado', //Produtos desmembrados finalizados
}
